import store from '../../../store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';

class ControleEntregaEPIController {
  public static async getControleEntregaEPI(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const estrutura: Estrutura = store.getters.estruturaGerencialAtual
    const nrEstrutura = estrutura.NRESTRUTURAM;
    const route = 'getControleEntregaEPI';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESTRUTURAM: nrEstrutura,
    };

    const response = await HttpRequest.get(route, params, showLoading);

    if (response.data.messages) {
      const errorMessage = response.data.messages[0].message;
      throw new ExpectedError(errorMessage);
    }

    const controleEntregaEPI: any[] = response.data.dataset.data;
    return controleEntregaEPI;

  };

  private static getNrOrg(): number {
    const nrOrg = store.getters.user.nrorg;
    const nrOrgInt = parseInt(nrOrg, 20);

    return nrOrgInt;
  }

  public static async getEpi(
    showLoading = true,
  ) {
    const route = 'getEpi';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const epis: any[] = response.data.dataset.data;

      return epis;
    } catch (err) {
      const message = 'Não foi possível carregar os históricos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async deleteHistoricoEpi(
    row: any,
    showLoading: boolean = true,
  ) {
    const route = 'deleteHistoricoEpi';

    const params = {
      requestType: 'Row',
      row: {
        ...row,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const success = response.data.dataset.data.success;

      const message = 'Histórico de EPI removido com sucesso!';
      SnackbarUtils.showMessage(message, 'success', 5000);

      return true;
    } catch (err) {
      const message = 'Não foi possível remover o histórico de EPI!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }
  }
}

export default ControleEntregaEPIController;